import React from 'react';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';

import 'ladda/dist/ladda-themeless.min.css';

const ActionButton = ({
  color,
  isSubmitting,
  name,
  type,
  click,
  className,
  icon,
  btnPad,
  textColor
}) => {
  return (
    <div className={className}>
      <LaddaButton
        type="submit"
        onClick={click}
        className={`w-full ${color} ${textColor} ${btnPad} rounded shadow btn-ladda flex items-center`}
        loading={isSubmitting}
        data-style={EXPAND_RIGHT}
        disabled={isSubmitting}
      >
        <span className="mr-1">{icon}</span>
        {name}
      </LaddaButton>
    </div>
  );
};

export default ActionButton;
